import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Apptext} from 'shared/classes/apptext';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Company } from 'shared/classes/company';

@Injectable()
export class ApptextsRepository {

  constructor(private http: Http) { }

  public getTexts(): Observable<Array<Apptext>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.apptexts}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public setText(text: Apptext): Observable<Apptext> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(text.text);

    return this.http.put(`${environment.apptexts}/${text._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public addText(text: Apptext): Observable<Apptext> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(text);

    return this.http.post(`${environment.apptexts}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteText(text: Apptext): Observable<boolean> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});

    return this.http.delete(`${environment.apptexts}/${text._id}`, options)
    .map((response: Response) => {
      return response.ok;
    });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/apptexts/repositories/apptexts.repository.ts